export default axiosInstance => {
  async function query({ platform, jwt }) {
    return (
      await axiosInstance(
        {
          method: "get",
          url: "/global/progress",
          params: { platform }
        },
        {
          headers: { jwt }
        }
      )
    ).data;
  }

  return {
    query
  };
};
